/**
 * A query's `placeholderData` that keeps the previous answer only when it was read for the same room
 * (#591). Within a room, paging, filtering or a new search term keeps the last rows on screen while the
 * next arrive, so a table does not blink empty; across a room switch it keeps nothing, or room A's rows —
 * with their buttons — would sit under room B's header until B's answer arrived.
 *
 * Every room-scoped key in this app carries the room id second (`['tournaments', roomId, …]`), which is
 * also what lets one invalidation reach a room's whole list; that position is what this reads.
 */
export function sameRoom(roomId: string | null) {
  return <T>(previous: T | undefined, previousQuery?: { queryKey: readonly unknown[] }): T | undefined =>
    previousQuery?.queryKey[1] === roomId ? previous : undefined;
}
